import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  BooleanField,
  BooleanInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  // RichTextInput,
  ReferenceInput,
  ArrayInput,
  SimpleFormIterator,
  ArrayField,
  ReferenceField,
  Create,
  Show,
  SimpleShowLayout,
  useRecordContext,
  RecordContextProvider,
} from 'react-admin'

import { CustomRichTextInput } from '../components/CustomRichTextInput'

const ReferenceArrayField = ({ source, reference, label }) => {
  const record = useRecordContext()
  const ids = record?.[source] || []

  if (!Array.isArray(ids) || ids.length === 0) {
    return null
  }

  // Transform array of IDs to array of objects for ArrayField
  const transformedRecord = {
    ...record,
    [source]: ids.map((id) => ({ id })),
  }

  return (
    <RecordContextProvider value={transformedRecord}>
      <ArrayField source={source} label={label}>
        <Datagrid>
          <ReferenceField source="id" reference={reference} link="show" />
        </Datagrid>
      </ArrayField>
    </RecordContextProvider>
  )
}

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const GroupList = ({ isEdit, isDelete }) => (
  <List filters={[<BooleanInput key="filter-isRestricted" source="isRestricted" />]}>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <RichTextField source="description" />
      <BooleanField source="isRestricted" />
      <BooleanField source="isPaymentRequired" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const GroupEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" fullWidth />
      <TextInput source="description" fullWidth multiline rows={2} />
      <BooleanInput source="isRestricted" />
      <BooleanInput source="isPaymentRequired" />
      <ArrayInput source="courseIds">
        <SimpleFormIterator
          fullWidth
          getItemLabel={(index) => `#${index + 1}`}
          sx={{
            // Keep the item label from growing and colliding with iterator action buttons
            '& .RaSimpleFormIterator-index': {
              display: 'block !important',
              width: '4ch',
              minWidth: '4ch',
              maxWidth: '4ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '@media (max-width: 899.95px)': {
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
              },
            },
            // Inputs area becomes 1col on mobile, 2col on big screens
            '& .RaSimpleFormIterator-form': {
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                // md: 'repeat(2, 1fr)',
              },
              gap: 1,
              alignItems: 'flex-start',
              width: '100%',
              pt: 1.5,
              flex: '1 1 auto',
              minWidth: 0,
            },
            '& .RaSimpleFormIterator-action': {
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
          }}
        >
          <ReferenceInput source="" reference="courses" />
        </SimpleFormIterator>
      </ArrayInput>
      <ArrayInput source="examIds">
        <SimpleFormIterator
          fullWidth
          getItemLabel={(index) => `#${index + 1}`}
          sx={{
            // Keep the item label from growing and colliding with iterator action buttons
            '& .RaSimpleFormIterator-index': {
              display: 'block !important',
              width: '4ch',
              minWidth: '4ch',
              maxWidth: '4ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '@media (max-width: 899.95px)': {
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
              },
            },
            // Inputs area becomes 1col on mobile, 2col on big screens
            '& .RaSimpleFormIterator-form': {
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
              },
              gap: 1,
              alignItems: 'flex-start',
              width: '100%',
              pt: 1.5,
              flex: '1 1 auto',
              minWidth: 0,
            },
            '& .RaSimpleFormIterator-action': {
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
          }}
        >
          <ReferenceInput source="" reference="exams" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
)

export const GroupCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" fullWidth />
      <TextInput source="description" fullWidth multiline rows={2} />
      <BooleanInput source="isRestricted" />
      <BooleanInput source="isPaymentRequired" />
      <ArrayInput source="courseIds">
        <SimpleFormIterator
          fullWidth
          getItemLabel={(index) => `#${index + 1}`}
          sx={{
            // Keep the item label from growing and colliding with iterator action buttons
            '& .RaSimpleFormIterator-index': {
              display: 'block !important',
              width: '4ch',
              minWidth: '4ch',
              maxWidth: '4ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '@media (max-width: 899.95px)': {
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
              },
            },
            // Inputs area becomes 1col on mobile, 2col on big screens
            '& .RaSimpleFormIterator-form': {
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
              },
              gap: 1,
              alignItems: 'flex-start',
              width: '100%',
              pt: 1.5,
              flex: '1 1 auto',
              minWidth: 0,
            },
            '& .RaSimpleFormIterator-action': {
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
          }}
        >
          <ReferenceInput source="" reference="courses" />
        </SimpleFormIterator>
      </ArrayInput>
      <ArrayInput source="examIds">
        <SimpleFormIterator
          fullWidth
          getItemLabel={(index) => `#${index + 1}`}
          sx={{
            // Keep the item label from growing and colliding with iterator action buttons
            '& .RaSimpleFormIterator-index': {
              display: 'block !important',
              width: '4ch',
              minWidth: '4ch',
              maxWidth: '4ch',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
            '@media (max-width: 899.95px)': {
              '& .RaSimpleFormIterator-index': {
                display: 'block !important',
              },
            },
            // Inputs area becomes 1col on mobile, 2col on big screens
            '& .RaSimpleFormIterator-form': {
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
              },
              gap: 1,
              alignItems: 'flex-start',
              width: '100%',
              pt: 1.5,
              flex: '1 1 auto',
              minWidth: 0,
            },
            '& .RaSimpleFormIterator-action': {
              flexShrink: 0,
              whiteSpace: 'nowrap',
            },
          }}
        >
          <ReferenceInput source="" reference="exams" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
)

export const GroupShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <RichTextField source="description" />
      <BooleanField source="isRestricted" />
      <BooleanField source="isPaymentRequired" />
      <ReferenceArrayField source="courseIds" reference="courses" label="Courses" />
      <ReferenceArrayField source="examIds" reference="exams" label="Exams" />
    </SimpleShowLayout>
  </Show>
)
